//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import React, { useMemo } from 'react';
import styled from 'styled-components';
import dayjs from 'utils/dayjsConfig';
import SentryWrap from 'components/Sentry';

//  -- Constants ----------------------
import COLOR from 'utils/constants/color';


//  ----------------------------------------------------------------------------
//  Styles
//  ----------------------------------------------------------------------------
const Wrapper = styled.button`
    align-items: center;
    background-color: transparent;
    border: 1px dashed ${COLOR.black700};
    border-radius: 3px;
    color: ${COLOR.black200};
    cursor: pointer;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 4px;
    padding: 8px;
    transition: all 300ms ease;
    width: 100%;

    &:hover {
        border: 1px dashed ${COLOR.green500};
        color: ${COLOR.green100};
    }
`;
 
const Submission = ({
    data,
    onClick,
    classUsers
}) => {
    const studentName = useMemo(() => {
        const user = classUsers.find(
            ({ id }) => id === data?.user?.id
        );
        return `${user?.firstName || ''} ${user?.lastName || ''}`.trim();
    }, [classUsers, data?.user?.id]);
 
    const formattedDate = useMemo(() => {
        if (!data?.createdAt) return '';
        return dayjs(Number(data.createdAt)).format('MMM DD, YYYY hh:mm a');
    }, [data?.createdAt]);
 
    return (
        <SentryWrap>
            <Wrapper onClick={onClick}>
                <span>{studentName}</span>
                <span>{formattedDate}</span>
            </Wrapper>
        </SentryWrap>
    )
}
 
export default Submission;